export enum ViewMode {
  Onboarding = 'onboarding',
  Default = 'default'
}
